import React from 'react';
import { Modal } from 'react-bootstrap';

const StatusBadge = ({ result }) => {
    const isSuccess = result === 'SUCCESS';

    return (
        <span
            className={`pms-update-history-status ${
                isSuccess ? 'pms-update-history-status--success' : 'pms-update-history-status--error'
            }`}
        >
            <i className={`bi ${isSuccess ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
            {isSuccess ? 'Success' : 'Failed'}
        </span>
    );
};

function DetailRow({ label, value, mono = false }) {
    if (!value) {
        return null;
    }

    return (
        <div className="pms-update-history-detail-row">
            <span className="pms-update-history-detail-row__label">{label}</span>
            <span className={`pms-update-history-detail-row__value ${mono ? 'font-monospace' : ''}`}>
                {value}
            </span>
        </div>
    );
}

function PmsUpdateHistoryDetailsModal({ show, onClose, item }) {
    if (!item) {
        return null;
    }

    const isError = item.result === 'ERROR';

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="lg"
            dialogClassName="pms-update-history-modal"
            contentClassName="pms-update-history-modal__content"
        >
            <Modal.Header className="pms-update-history-modal__header border-0">
                <div className="d-flex align-items-center gap-3 min-width-0 flex-grow-1">
                    <span className="ecx-page-icon-badge flex-shrink-0" style={{ width: '2.5rem', height: '2.5rem' }}>
                        <i className="bi bi-journal-text"></i>
                    </span>
                    <div className="min-width-0">
                        <Modal.Title className="h5 mb-1 fw-normal">Sync Log Details</Modal.Title>
                        <div className="small text-muted">{item.createdAt || '—'}</div>
                    </div>
                </div>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary rounded-pill ecx-modal__close-btn ms-auto flex-shrink-0"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <i className="bi bi-x-lg"></i>
                </button>
            </Modal.Header>

            <Modal.Body className="pms-update-history-modal__body">
                <div className="d-flex flex-wrap gap-2 mb-3">
                    <StatusBadge result={item.result} />
                    {item.pmsType && (
                        <span className="pms-update-history-pms-badge">
                            <i className="bi bi-laptop"></i>
                            {item.pmsType}
                        </span>
                    )}
                </div>

                <div className="pms-update-history-modal__details">
                    <DetailRow label="Date & Time" value={item.createdAt} />
                    <DetailRow label="Sync ID" value={item.id} mono />
                    <DetailRow label="Clinic ID" value={item.clinicId} mono />
                    <DetailRow label="Modified At" value={item.modifiedAt} />
                </div>

                <div className="pms-update-history-modal__notes mt-3">
                    <div className="pms-update-history-modal__notes-label">Notes</div>
                    <div
                        className={`pms-update-history-modal__notes-content ${
                            isError ? 'pms-update-history-modal__notes-content--error' : ''
                        }`}
                    >
                        {item.notes || 'No update details recorded.'}
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="pms-update-history-modal__footer border-0">
                <button type="button" className="btn btn-sm btn-outline-secondary rounded-pill ecx-modal__footer-close-btn" onClick={onClose}>
                    <i className="bi bi-x-circle me-1"></i>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default PmsUpdateHistoryDetailsModal;
